// The picker reads the same Liquid-rendered fragments as a variant deep link.
for (const panel of document.querySelectorAll('[data-lr-stacked]')) {
  const picker = panel.querySelector('[data-size-picker]');
  const radios = [...picker.querySelectorAll('input[type=radio]')];
  const form = panel.querySelector('product-form form');
  const idInput = form.elements.namedItem('id');
  const result = panel.querySelector('[data-size-result]');
  const actions = [...form.querySelectorAll('[data-size-action]')];
  const dock = panel.querySelector('[data-size-dock]');
  const pickup = panel.querySelector('[data-size-pickup]');
  let current;
  let submitting = false;
  let unit = 'cm';
  try { if (localStorage.getItem('metric') === 'ft') unit = 'ft'; } catch {}

  function dimensions(title) {
    // Keep shape qualifiers, including round, oval and runner, in either unit.
    return title.replace(/(\d+(?:\.\d+)?)\s*(?:cm)?\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm\b/gi,
      (_, first, second) => unit === 'cm' ? first + ' × ' + second + ' cm' : feet(first) + ' × ' + feet(second))
      .replace(/(\d+(?:\.\d+)?)\s*cm\b/gi, (label, value) => unit === 'ft' ? feet(value) : label);
  }
  function feet(cm) {
    const inches = Math.round(Number(cm) / 2.54);
    return Math.floor(inches / 12) + '′ ' + inches % 12 + '″';
  }
  function render() {
    for (const radio of radios) {
      radio.checked = radio === current;
      radio.labels[0].querySelector('[data-size-label]').textContent = dimensions(radio.dataset.title);
    }
    const unitSwitch = panel.querySelector('[data-size-unit-switch]');
    if (unitSwitch) {
      unitSwitch.setAttribute('aria-checked', String(unit === 'ft'));
      unitSwitch.closest('.custom-converter').classList.toggle('active', unit === 'ft');
    }
    const label = current ? dimensions(current.dataset.title) : '';
    const heading = panel.querySelector('[data-size-heading]');
    heading.textContent = current ? ' · ' + label : '';
    heading.closest('legend').classList.toggle('visually-hidden', !current);
    result.replaceChildren();
    if (current) {
      result.append(current.closest('.lr-size-card').querySelector('template').content.cloneNode(true));
      result.querySelector('[data-size-display]').textContent = label;
    }
    const price = current ? result.querySelector('.lr-size-price') : panel.querySelector('[data-size-range]').content;
    const top = panel.querySelector('[data-size-top]');
    top.replaceChildren(...[...price.childNodes].map(node => node.cloneNode(true)));
    const summary = dock.querySelector('[data-size-sticky]');
    summary.replaceChildren();
    if (current) summary.append(label, document.createElement('br'));
    summary.append(...[...top.childNodes].map(node => node.cloneNode(true)));
    const state = current?.dataset.state;
    const action = !current ? 'Choose a size' : state === 'soldout' ? 'Sold out' : state === 'preorder' ? 'Pre-order' : 'Add to Basket';
    for (const button of actions) {
      button.textContent = action;
      button.disabled = submitting || state === 'soldout';
      button.type = current ? 'submit' : 'button';
    }
  }
  function select(radio, writeURL) {
    current = radio;
    submitting = false;
    idInput.value = current?.value || '';
    idInput.disabled = !current;
    idInput.dispatchEvent(new Event('change', {bubbles:true}));
    const installment = panel.querySelector('#product-form-installment [name=id]');
    if (installment) {
      installment.form.hidden = !current;
      installment.value = idInput.value;
      installment.dispatchEvent(new Event('change', {bubbles:true}));
    }
    if (writeURL && current) {
      const url = new URL(location.href);
      url.searchParams.set('variant', current.value);
      history.replaceState(history.state, '', url);
    }
    render();
    if (pickup) {
      pickup.removeAttribute('available');
      pickup.querySelector('pickup-availability-preview')?.remove();
      document.querySelector('pickup-availability-drawer')?.remove();
      pickup.dataset.variantId = current?.value || '';
      if (current && current.dataset.state !== 'soldout') {
        const id = current.value;
        customElements.whenDefined('pickup-availability').then(() => {
          if (current?.value === id) pickup.fetchAvailability(id);
        });
      }
    }
  }
  function fromURL() {
    const id = new URL(location.href).searchParams.get('variant');
    select(radios.length === 1 ? radios[0] : radios.find(radio => radio.value === id), false);
  }
  function focusPicker() {
    radios[0].focus({preventScroll:true});
    picker.scrollIntoView({block:'center'});
  }
  picker.addEventListener('change', event => {
    if (radios.includes(event.target)) select(event.target, true);
  });
  panel.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (button?.hasAttribute('data-size-unit-switch')) {
      unit = unit === 'cm' ? 'ft' : 'cm';
      try { localStorage.setItem('metric',unit); } catch {}
      render();
    } else if (button?.hasAttribute('data-size-action') && !current) focusPicker();
  });
  form.addEventListener('submit', event => {
    if (!current || current.dataset.state === 'soldout' || submitting || idInput.value !== current.value) {
      event.preventDefault();
      if (!current) focusPicker();
      return;
    }
    submitting = true;
    for (const button of actions) button.disabled = true;
    // Native successful cart navigation is observed by Shopify's product_added_to_cart event.
    setTimeout(() => { if (event.defaultPrevented) { submitting = false; render(); } }, 0);
  });
  const observer = new IntersectionObserver(([entry]) => {dock.hidden = entry.intersectionRatio >= 0.99;},
    {threshold:[0,0.99,1]});
  observer.observe(actions[0]);
  addEventListener('popstate', fromURL);
  addEventListener('pageshow', event => { if (event.persisted) fromURL(); });
  fromURL();
}
